module.exports = __webpack_public_path__ + "res/Roboto-Bold-webfont.eot?254d42b34a77bd40ef922522b5437c2f";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Bold-webfont.eot
// module id = 26
// module chunks = 0